
import BaseApi from "./BaseApi";
import { ApiPaths } from './ApiPaths';

const create = () => {
  const api = BaseApi.create({});

    const searchEmployees = (searchString, onlyMyOffices, impersonateUser) => api.get(ApiPaths.SEARCH_EMPLOYEE(searchString, onlyMyOffices, impersonateUser)); 
    const getEmployeeInfo = (associateId) => api.get(ApiPaths.GET_EMPLOYEE_INFO(associateId));
    const saveAssociateOffices = (associateId, payload) => api.put(ApiPaths.ADD_EMPLOYEE_OFFICES(associateId), payload);    
    const getEmployeeOffices = (associateId) => api.get(ApiPaths.GET_ASSOCIATE_OFFICES(associateId));
    const getEmployees = (officeId, offset, sortType, reversed) => api.get(ApiPaths.GET_EMPLOYEES(officeId, offset, sortType, reversed));

    /**
     * Returns a list of offices that an associate is currently actively working in.
     * @param {any} associateId the id of the associate, as a long
     */
    const getAssociateOffices = (associateId) => api.get(ApiPaths.GET_ASSOCIATE_OFFICES(associateId));

    return {
       searchEmployees, getEmployeeInfo, saveAssociateOffices, getAssociateOffices, getEmployeeOffices, getEmployees  
    };
}
// let's return back our create method as the default.
export default {
    create
}

